import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import '../../Technical.css';

class AddVote extends Component {
    render() {
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                        Competition API
                </h1>
                    <div>
                        <h2 className="main-subheading">
                            allaboutme.pcs.add_vote</h2>
                        <div className="technical-main-content">
                            <p>
                                Adds a vote to a specified design. To avoid end-users from setting up automated
                                voting mechanisms, add_vote requires the use of a CAPTCHA. To use the CAPTCHA effectively
                                follow these steps:
                        </p>
                            <ul>
                                <li>First call <Link to="/technical/competitionapi/getcaptcha">allaboutme.pcs.get_captcha</Link></li>
                                <li>The <em>random</em> string obtained should be stored temporarily</li>
                                <li>The CAPTCHA image should be presented to the user using the <em>imageUrl</em></li>
                                <li>The user types in the text in the CAPTCHA image (the <em>password)</em></li>
                                <li>Call allaboutme.pcs.add_vote passing the <em>random</em> string and the <em>password</em>
                                    as parameters</li>
                            </ul>
                            <div>
                                <h3>
                                    Arguments</h3>
                                <ul>
                                    <li><b>api_key</b> (Required)
                                    <p>
                                            A valid API key that must be obtained from Thales.</p>
                                    </li>
                                    <li><b>method</b> (Required)
                                    <p>
                                            allaboutme.add_vote</p>
                                    </li>
                                    <li><b>card_image_id</b> (Required)
                                    <p>
                                            The ID of the design being voted for.</p>
                                    </li>
                                    <li><b>random</b> (Required)
                                    <p>
                                            The random string obtained by calling allaboutme.get_captcha.</p>
                                    </li>
                                    <li><b>password</b> (Required)
                                    <p>
                                            The string that corresponds to the CAPTCHA image presented to the end user.</p>
                                    </li>
                                </ul>
                                <br />
                            </div>
                            <div>
                                <h3>
                                    Example response XML payload</h3>
                                <pre>
                                    [empty-payload]
                                </pre>
                                <br />
                            </div>
                            <div>
                                <h3>
                                    Error codes</h3>
                                <ul>
                                    <li><b>-1 (General error)</b>
                                    <p>
                                            An internal error ocurred on the server. This is not dependent on the specific method
                                        or parameters passed. If the error persists, contact Thales.</p>
                                    </li>
                                    <li><b>1 (Invalid api_key)</b>
                                    <p>
                                            The <em>api_key</em> passed is not valid or is disabled. Check the key to make sure
                                        it is correct. If so, contact Thales.</p>
                                    </li>
                                    <li><b>2 (Invalid method)</b>
                                    <p>
                                            The method you attempted to call is invalid. Check the <em>method</em> parameter.</p>
                                    </li>
                                    <li><b>3 (No method specified)</b>
                                    <p>
                                            The required <em>method</em> parameter was not informed.</p>
                                    </li>
                                    <li><b>201 (No card_image_id specified)</b>
                                    <p>
                                            The required <em>card_image_id</em> parameter was not informed.</p>
                                    </li>
                                    <li><b>202 (No random specified)</b>
                                    <p>
                                            The required <em>random</em> parameter was not informed.</p>
                                    </li>
                                    <li><b>203 (No password specified)</b>
                                    <p>
                                            The required <em>password</em> parameter was not informed.</p>
                                    </li>
                                    <li><b>204 (random doesn&apos;t validate)</b>
                                    <p>
                                            The <em>random</em> parameter is either invalid or it has expired on the server
                                        and can no longer be used to submit a vote.</p>
                                    </li>
                                    <li><b>205 (password doesn&apos;t verify)</b>
                                    <p>
                                            The <em>password</em> parameter doesn&apos;t match the text displayed in the CAPTCHA
                                        image.</p>
                                    </li>
                                </ul>
                                <br />
                            </div>
                        </div>
                        <div className="document-content-back">
                            <Link className="document-content-link" to='/technical/competitionapi'>Back</Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AddVote;